<template>
  <div class="container md-layout" v-if="!loading">
    <!-- Equipo -->
    <md-card class="md-layout-item md-size-100">
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>emoji_events</md-icon>
        </div>
        <h4 class="title">{{ $t("teams.detail.title") }}</h4>
      </md-card-header>
      <md-card-content class="md-layout">
        <md-field
          :class="{
            'md-error': $v.teamModel.name.$error && $v.teamModel.name.$invalid,
            'md-valid': !$v.teamModel.name.$error && !$v.teamModel.name.$invalid
          }"
        >
          <label>{{ $t("teams.detail.name") }}</label>
          <md-input
            v-model.trim="$v.teamModel.name.$model"
            type="text"
          ></md-input>
          <slide-y-down-transition>
            <md-icon
              class="error"
              v-show="$v.teamModel.name.$error && $v.teamModel.name.$invalid"
            >
              close
            </md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon
              class="success"
              v-show="!$v.teamModel.name.$error && !$v.teamModel.name.$invalid"
            >
              done
            </md-icon>
          </slide-y-down-transition>
        </md-field>

        <!-- Shield -->
        <div class="md-layout md-gutter">
          <md-card class="md-layout-item w-auto">
            <md-card-header-text>
              <h4 class="title">{{ $t("teams.detail.shield") }}</h4>
            </md-card-header-text>
            <md-card-media-actions>
              <md-card-media class="shield-preview">
                <img v-if="teamModel.shield" :src="getUrlShield(teamModel.shield)" alt="Live preview">
              </md-card-media>

              <md-card-actions>
                <md-button class="md-simple">
                  <label for="upload-shield">
                    <md-file @md-change="updateShield" name="upload-shield" id="upload-shield" style="display:none"></md-file>
                    <md-icon>edit</md-icon> Editar
                  </label>
                </md-button>
              </md-card-actions>
            </md-card-media-actions>
          </md-card>
          <!-- Background game -->
          <md-card class="md-layout-item w-auto">
            <md-card-header-text>
              <h4 class="title">{{ $t("teams.detail.backgroundGameImage") }}</h4>
            </md-card-header-text>
            <md-card-media-actions>
              <md-card-media class="shield-preview">
                <img v-if="teamModel.backgroundGameImage" :src="getUrlBackgroundImage(teamModel.backgroundGameImage)" alt="Live preview">
              </md-card-media>

              <md-card-actions>
                <md-button class="md-simple">
                  <label for="upload-background">
                    <md-file @md-change="updateBackgroundImage" name="upload-background" id="upload-background" style="display:none"></md-file>
                    <md-icon>edit</md-icon> Editar
                  </label>
                </md-button>
              </md-card-actions>
            </md-card-media-actions>
          </md-card>
          <!-- Goal animation -->
          <md-card class="md-layout-item w-auto">
            <md-card-header-text>
              <h4 class="title">{{ $t("teams.detail.goalAnimation") }}</h4>
            </md-card-header-text>
            <md-card-media-actions>
              <md-card-media class="shield-preview">
                <video v-if="teamModel.goalAnimation" controls playsinline="" muted="muted">
                  <source :src="getUrlGoalAnimation(teamModel.goalAnimation)" type="video/mp4">
                </video>
              </md-card-media>

              <md-card-actions>
                <md-button class="md-simple">
                  <label for="upload-goal">
                    <md-file @md-change="updateGoalAnimation" accept="video/mp4,video/x-m4v,video/*" name="upload-goal" id="upload-goal" style="display:none"></md-file>
                    <md-icon>edit</md-icon> Editar
                  </label>
                </md-button>
              </md-card-actions>
            </md-card-media-actions>
          </md-card>
        </div>
        
      </md-card-content>

      <md-card-actions class="actions">
        <md-button class="md-info" @click="teamUpdate" :disabled="submitted">
          {{ $t("teams.detail.save") }}
        </md-button>
        <md-button class="md-simple md-danger" @click="teamDelete" :disabled="submitted">
          {{ $t("teams.detail.delete") }}
          <md-icon>delete</md-icon>
        </md-button>
      </md-card-actions>
    </md-card>

    <!-- Avatares del equipo -->
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>sentiment_satisfied_alt</md-icon>
        </div>
        <h4 class="title">{{ $t("avatars.list.title") }}</h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout md-gutter avatars md-alignment-center">
          <!-- Lista de avatares -->
          <avatar-card
            v-for="avatar in avatars"
            :avatar="avatar"
            :key="avatar.id"
            @avatarDelete="avatarDelete"
            @avatarEdit="avatarUpdate"
          ></avatar-card>

          <!-- Boton agregar avatar -->
          <md-card class="md-layout-item md-size-20 card-add-avatar">
            <md-card-content>
              <input
                type="file"
                style="display:none;"
                ref="uploadAvatar"
                multiple
                @change="avatarCreate"
              />
              <div
                class="button-add-avatar"
                @click="$refs.uploadAvatar.click()"
              >
                <md-icon class="md-size-5x">add</md-icon>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import storage from "@/plugins/azure-storage";
import { required } from "vuelidate/lib/validators";
import { SlideYDownTransition } from "vue2-transitions";
import AvatarCard from "@/components/Teams/AvatarCard";

export default {
  components: {
    AvatarCard,
    SlideYDownTransition
  },
  data() {
    return {
      submitted: false,
      loading: true,
      fileGoalMaxSize: false,
      teamId: "",
      teamModel: {
        name: "",
        shield: "",
        backgroundGameImage: "",
        goalAnimation: ""
      },
      avatars: []
    };
  },
  mounted() {
    this.teamId = this.$route.params.id;

    if (this.$store.state.StuffModule.teams.length === 0) {
      this.$store.dispatch("teamsGet").then(_ => {
        const team = this.$store.getters.getTeamById(this.teamId);
        this.teamModel = { ...team };
        this.loading = false
      });
    } else {
      const team = this.$store.getters.getTeamById(this.teamId);
      this.teamModel = { ...team };
      this.loading = false
    }

    this.getAvatars();
  },
  methods: {
    getAvatars() {
      this.$store.dispatch("getAvatars", this.teamId).then(avatars => {
        this.avatars = avatars;
      });
    },
    getUrlShield(shield) {
      return `${process.env.VUE_APP_CDN_URL_SHIELDS}${shield}`;
    },
    getUrlBackgroundImage(image) {
      return `${process.env.VUE_APP_CDN_URL_BACKGROUND_GAME_IMAGES}${image}`
    },
    getUrlGoalAnimation(video) {
      return `${process.env.VUE_APP_CDN_URL_GOAL}${video}`
    },
    async uploadShield(FileList) {
      const file = FileList[0];
      return await storage.updateFile({
        file,
        container: process.env.VUE_APP_CDN_CONTAINER_SHIELDS
      });
    },
    async uploadBackgroundImage(FileList) {
      const file = FileList[0];
      return await storage.updateFile({
        file,
        container: process.env.VUE_APP_CDN_CONTAINER_GAME_IMAGES
      });
    },
    async uploadAvatar(file) {
      return await storage.updateFile({
        file,
        container: process.env.VUE_APP_CDN_CONTAINER_AVATARS
      });
    },
    async uploadGoalAnimation(FileList) {
      const file = FileList[0];
      return await storage.updateFile({
        file,
        container: process.env.VUE_APP_CDN_CONTAINER_GOAL
      })
    },
    async updateShield(FileList) {
      this.submitted = true;
      const fileName = await this.uploadShield(FileList);
      this.teamModel.shield = fileName;
      this.submitted = false;
      return;
    },
    async updateBackgroundImage(FileList) {
      this.submitted = true;
      const fileName = await this.uploadBackgroundImage(FileList);
      this.teamModel.backgroundGameImage = fileName;
      this.submitted = false;
      return;
    },
    async updateGoalAnimation(FileList) {
      this.submitted = true;
      if (FileList[0].size > 1572864) {
          this.$notify({
            message: this.$t(`notifications.team.updateGoalSize`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
        return;
      } else {
        const fileName = await this.uploadGoalAnimation(FileList);
        this.teamModel.goalAnimation = fileName;
        this.submitted = false;
        return;
      }
    },
    async teamUpdate() {
      this.$v.$touch();
      this.submitted = true;

      if (!this.$v.$invalid) {
        const response = await this.$store.dispatch("teamUpdate", this.teamModel);
        if (response != undefined) {
          this.$notify({
            message: this.$t(`notifications.team.update`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
          this.submitted = false;
        } else {
          this.$store.dispatch("openModalError")
        }
        return;
      }
    },
    async avatarCreate(ev) {
      this.submitted = true;
      ev.target.files.forEach(async element => {  
        const fileName = await this.uploadAvatar(element);
        const response = await this.$store.dispatch("avatarCreate", {
          teamId: this.teamModel.id,
          avatar: fileName
        })
        if (response != undefined) {
          this.$notify({
            message: this.$t(`notifications.team.avatars.create`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
          this.getAvatars();
        } else {
          this.$store.dispatch("openModalError")
        }
      });
      this.submitted = false;
      return;
    },
    async avatarUpdate({ ev, avatar }) {
      this.submitted = true;
      const fileName = await this.uploadAvatar(ev.target.files[0]);
      const response = await this.$store.dispatch("avatarUpdate", {
        id: avatar.id,
        avatar: fileName
      })
      if (response != undefined) {
        this.$notify({
          message: this.$t(`notifications.team.avatars.update`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.getAvatars()
      } else {
        this.$store.dispatch("openModalError")
      }
      this.submitted = false;
      return;
    },
    async avatarDelete(avatar) {
      this.submitted = true;
      const response = await this.$store.dispatch("avatarDelete", avatar)
      if (response != undefined) {
        const index = this.avatars.indexOf(avatar);
        this.avatars.splice(index, 1);
        this.$notify({
          message: this.$t(`notifications.team.avatars.remove`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
      } else {
        this.$store.dispatch("openModalError")
      }
      this.submitted = false;
      return;
    },
    async teamDelete() {
      this.submitted = true;
      const reponse = await this.$store.dispatch("teamDelete", this.teamModel.id);
      this.submitted = false;
      if (response != undefined) {
        this.$notify({
          message: this.$t(`notifications.team.remove`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.$router.push("/list/teams");
      } else {
        this.$store.dispatch("openModalError")
      }
    }
  },
  validations: {
    teamModel: {
      name: {
        required
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

.w-auto {
  width: auto;
}

.md-flex {
  display: flex;
}

.avatars {
  background-color: $gray-lighter;
  border-radius: $border-radius-base;
  margin-left: auto;
  margin-right: auto;
}

.title {
  margin-top: $margin-base;
}

.shield-preview {
  background: $gray-lighter;
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: center;
  img {
    object-fit: contain;
  }
}

.md-layout.md-gutter > .md-layout-item {
  margin-left: 20px;
  margin-right: 20px;
}

.card-add-avatar {
  justify-content: center;
  align-items: center;
  order: 9999;

  .button-add-avatar {
    cursor: pointer;
  }

  .md-card-content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.actions {
  display: flex;
  justify-content: space-between;
}
</style>
